export const EGYPTIAN_CITIES = [
    "6th of October City",
    "Abu Kabir",
    "Alexandria",
    "Arish",
    "Aswan",
    "Asyut",
    "Banha",
    "Belbeis",
    "Beni Suef",
    "Cairo",
    "Damanhur",
    "Damietta",
    "El-Mahalla El-Kubra",
    "Fayyum",
    "Giza",
    "Hurghada",
    "Ismailia",
    "Kafr El Dawwar",
    "Kafr el-Sheikh",
    "Luxor",
    "Marsa Matruh",
    "Port Said",
    "Qalyub",
    "Qena",
    "Shibin El Kom",
    "Shubra El-Kheima",
    "Sohag",
    "Suez",
    "Tanta",
    "Zagazig",
    "al-Mansura",
    "al-Minya"
];
